import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { t } from 'i18next';
import { DataChip } from '../../../../common/components/DataChip';
import { SEVERITY_COLORS, getTagLabel } from '../../../../common/enums/Severity';
import { COMMON_ISSUE_GROUP_SX } from '../../constants/constants';
import { Issue } from '../models/valueObjects/Issue';

type Props = {
  title: string;
  issues: Issue[];
};

export const IssueGroup = ({ title, issues }: Props) => {
  if (issues.length === 0) {
    return null;
  }

  return (
    <Table sx={COMMON_ISSUE_GROUP_SX}>
      <TableHead>
        <TableRow>
          <TableCell colSpan={2}>{title}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>{t('issue')}</TableCell>
          <TableCell align="right" width={125}>
            {t('severity.severity')}
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {issues.map((i) => (
          <TableRow key={i.getNumber()}>
            <TableCell>
              <Typography variant="body2" fontWeight="bold" mb={0.5}>
                {i.getNumber()}. {i.getTitle()}
              </Typography>
              <Typography variant="body2">{i.getShortExplanation()}</Typography>
            </TableCell>
            <TableCell align="right">
              <DataChip
                textColor={SEVERITY_COLORS[i.getSeverity()].text}
                borderColor={SEVERITY_COLORS[i.getSeverity()].main}
                backgroundColor={SEVERITY_COLORS[i.getSeverity()].background}
                label={getTagLabel(i.getSeverity())}
                boxSx={{ ml: 'auto', width: '5rem' }}
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
